import { LOCAL_HOST, QA_HOST } from "src/app/overview-v2/document-transcription-v2/shared/constants"

export const isDevelopmentEnv = (currentHost: string) => {
  return [QA_HOST, LOCAL_HOST].indexOf(currentHost) > -1;
}